export const removeEvent = (event: string, argName: string): void => {
  let gtmDataLayer = window.dataLayer || [];

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  gtmDataLayer = [...gtmDataLayer].filter(item => item.event !== argName);
};
